<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.historicalType')" prop="template">
            <BjSelectLov v-model="queryParams.template" clearable :option-list="templateList" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.searchName')" prop="chargeItemCode">
            <BjSelectLov v-model="queryParams.chargeItemCode" clearable :option-list="chargeItemCodeList" />
          </el-form-item>
        </el-col>
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'startDate'">
                <span>{{ scope.row[col.prop] | timeChanges }}</span>
              </template>
              <template v-else-if="col.prop === 'endDate'">
                <span>{{ scope.row[col.prop] | timeChanges }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, props.row)">
                <span class="el-dropdown-link">
                  {{ $t('AccountManagement.common.operate') }} <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="1">{{ $t('addText') }}</el-dropdown-item>
                  <el-dropdown-item :command="2">{{ $t('billingPage.historicalHis') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @handleConfirm="handleConfirm" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from '@/api';
import DataForm from './components/DataForm.vue';
import moment from 'moment';
const defaultForm = () => {
  return {
    template: null,
    chargeItemCode: null,
  }
}
export default {
  name: 'BusinessBillingHistorical',
  components: {DataForm},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      // 查询参数
      queryApi: billApi.getHistoricalList,
      queryParams: defaultForm(),
      labelList: [
        { label: this.$t('billingPage.historicalType'), prop: 'templateType', isCheck: true, disabled: false },
        { label: this.$t('billingPage.group'), prop: 'group', isCheck: true, disabled: false },
        { label: this.$t('billingPage.searchName'), prop: 'chargeItemCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.historicalBB'), prop: 'cost2b', isCheck: true, disabled: false },
        { label: this.$t('billingPage.historicalCC'), prop: 'cost2c', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.endDate'), prop: 'endDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Operator'), prop: 'operator', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      templateList:[],
      chargeItemCodeList:[],
    };
  },
  computed: {},
  created() {
    this.getChIteList();
    this.getTemList();
  },
  methods: {
    getChIteList() {
      billApi.getTempList().then(e => {
        this.templateList = e.data.map(item => {
          return {
            label: item.templateType,
            value: item.id,
          };
        });
      });
    },
    getTemList() {
      billApi.getChItemList().then(e => {
        this.chargeItemCodeList = e.data.map(item => {
          return {
            label: item.chargeItemCode,
            value: item.chargeItemCode,
          };
        });
      });
    },
    // 查看
    onView(row) {
      billApi.viewHistoricalList({template:row.templateId,chargeItemCode:row.chargeItemCode}).then(e => {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 'view';
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(e.data));
      });
    },
    command(val, item) {
      if (val === 1) { this.createNew(item); }
      if (val === 2) { this.onHistory(item); }
    },
    // 新增
    createNew(row) {
      this.$refs.DataForm.drawer = true;
      this.$refs.DataForm.openType = 'add';
      this.$nextTick(() => {
        // this.$refs.DataForm.form.chargeItemCode = row.chargeItemCode;
        this.setDataForm(row);
      });
    },
    // 新增时设置当前行数据为默认值， 除开始时间， 开始时间取当前时间
    setDataForm(row) {
      const newObj = {};
      const cloneRow = JSON.parse(JSON.stringify(row));
      for (const i in this.$refs.DataForm.form) {
        if (Object.prototype.hasOwnProperty.call(cloneRow, i) && i !== 'startDate') {
          newObj[i] = cloneRow[i];
        }
      }
      this.$refs.DataForm.form = {
        ...newObj,
        startDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
    },
    // 历史
    onHistory(row) {
      this.$router.push({
        name: 'BusinessBillingHistoricaCost',
        query: {template:row.templateId,chargeItemCode:row.chargeItemCode},
      });
    },
    // 子页面回调执行 '新增' 方法
    handleConfirm(row) {
      billApi.addHistoricalList(row).then(e => {
        this.$refs.DataForm.handleClose();
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams = defaultForm();
      return new Promise(resolve => {
        resolve();
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
